
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  dispatchGetVirtualNodesList
} from "@/store/mlm/actions";
import {
  readVirtualNodesList
} from "@/store/mlm/getters";
// import VirtualNodesAnnual from "@/components/Main/Nodes/VirtualNodesAnnual.vue";
import PackagePaymentVirtualModal from "@/components/Main/Nodes/PackagePaymentVirtualModal.vue";
@Component({
  components: {
    // VirtualNodesAnnual,
    PackagePaymentVirtualModal,
  },
})
export default class VirtualNodes extends Vue {

  public selectedVirtualPackage = null
  public showVirtualPackagePaymentModal = false

  // methods
  public handleOpenVirtualPackagePaymentModal(pack) {
    this.selectedVirtualPackage = pack;
    this.showVirtualPackagePaymentModal = true;
  }

public async mounted() {
  if(this.virtualNodesList.length == 0){
        await dispatchGetVirtualNodesList(this.$store)
    }
}

get virtualNodesList() {
    return readVirtualNodesList(this.$store);
  }
}
